import TogglesPage from './Toggles.container';

export default TogglesPage;
